window.theme = window.theme || {};
/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.ProductRecommendations = (function () {
    function ProductRecommendations(container) {
        var baseUrl = container.dataset.baseUrl;
        var productId = container.dataset.productId;
        var initRecommendedProductsSlick = function () {
            var initSlick = function () {
                $('.product-recommendations__items').slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            },
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            },
                        }
                    ],
                    prevArrow: '<button class="product-recommendation__arrow product-recommendation__arrow--prev slide-arrow prev-arrow"></button>',
                    nextArrow: '<button class="product-recommendation__arrow product-recommendation__arrow--next slide-arrow next-arrow"></button>'
                });
            };

            if (document.querySelector('#slick-js')) {
                initSlick();
                return;
            }

            var s = document.createElement('script');
            var l = document.createElement('link');
            var lCustom = document.createElement('link');

            s.id = "slick-js";
            l.id = "slick-css";
            l.rel = "stylesheet";
            lCustom.rel = "stylesheet";
            lCustom.id = "recommended-custom-css";
            l.addEventListener('load', function () {
                s.addEventListener('load', function () {
                    initSlick();
                });
                s.src = getAssetUrl('slick.min.js');
                document.body.append(s);
            });
            l.href = getAssetUrl("slick.css");
            lCustom.href = getAssetUrl("recommended-products.css");

            document.head.append(l);
            document.head.append(lCustom);
        };

        var recommendationsSectionUrl =
            baseUrl +
            '?section_id=product-recommendations&product_id=' +
            productId +
            '&limit=5';

        window.performance.mark(
            'debut:product:fetch_product_recommendations.start'
        );

        fetch(recommendationsSectionUrl)
            .then(function (response) {
                return response.text();
            })
            .then(function (productHtml) {
                if (productHtml.trim() === '') return;

                container.innerHTML = productHtml;
                container.innerHTML = container.firstElementChild.innerHTML;

                initRecommendedProductsSlick();
                if (window.SPR != undefined) {
                    window.SPR.$(document).ready(function() {
                        return SPR.registerCallbacks(),
                        SPR.initRatingHandler(),
                        SPR.initDomEls(),
                        SPR.loadProducts(),
                        SPR.loadBadges()
                    });
                }

                window.performance.mark(
                    'debut:product:fetch_product_recommendations.end'
                );

                performance.measure(
                    'debut:product:fetch_product_recommendations',
                    'debut:product:fetch_product_recommendations.start',
                    'debut:product:fetch_product_recommendations.end'
                );
            });
    }

    return ProductRecommendations;
})();

theme.ProductRecommendationCount = (function () {
    function ProductRecommendationCount(container) {
        var baseUrl = container.dataset.baseUrl;
        var productId = container.dataset.productId;
        var recommendationsSectionUrl =
            baseUrl +
            '?section_id=product-recommendation-count&product_id=' +
            productId;

        window.performance.mark(
            'debut:product:fetch_product_recommendation_count.start'
        );

        fetch(recommendationsSectionUrl)
            .then(function (response) {
                return response.text();
            })
            .then(function (productHtml) {
                if (productHtml.trim() === '') return;

                container.innerHTML = productHtml;
                container.innerHTML = container.firstElementChild.innerHTML;

                window.performance.mark(
                    'debut:product:fetch_product_recommendation_count.end'
                );

                performance.measure(
                    'debut:product:fetch_product_recommendation_count',
                    'debut:product:fetch_product_recommendation_count.start',
                    'debut:product:fetch_product_recommendation_count.end'
                );

                $(container).trigger('product:fetch_product_recommendation_count.end');
            });
    }
    return ProductRecommendationCount;
})();

document.addEventListener('DOMContentLoaded', function () {
    var sections = new theme.Sections();
    sections.register('product-recommendations', theme.ProductRecommendations);
    sections.register('product-recommendation-count', theme.ProductRecommendationCount);
});
